module.exports = __webpack_public_path__ + "static/media/20b-02_ST-2020-345x43mm-oleo-sobre-madera.f83e6f10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20b/20b-02_ST-2020-345x43mm-oleo-sobre-madera.jpg
// module id = 247
// module chunks = 0